import axios from 'axios';
import { Motion, presets } from '../motion';

export default function UpdatePopup({ announcement, onDismiss }) {
  if (!announcement) return null;

  const dismiss = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.post('/api/announcements/dismiss', {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch {}
    onDismiss();
  };

  return (
    <Motion {...presets.dialog} style={{
      position: 'fixed', inset: 0, zIndex: 9000,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px',
    }}>
      <div data-backdrop style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(6px)', WebkitBackdropFilter: 'blur(6px)' }} />
      <div data-card style={{
        position: 'relative',
        background: 'var(--surface2)', border: '1px solid var(--border)',
        borderRadius: '24px', width: '100%', maxWidth: '400px',
        boxShadow: '0 32px 80px rgba(0,0,0,0.6)',
        overflow: 'hidden',
      }}>
        {/* Purple top bar */}
        <div style={{
          background: 'linear-gradient(135deg, var(--purple), #7c3aed)',
          padding: '20px 22px 18px',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '4px' }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/>
              <path d="M13.73 21a2 2 0 01-3.46 0"/>
            </svg>
            <span style={{ fontFamily: 'Nunito', fontSize: '11px', fontWeight: 700, color: 'rgba(255,255,255,0.7)', letterSpacing: '1.5px', textTransform: 'uppercase' }}>
              Update
            </span>
          </div>
          <div style={{ fontFamily: 'Nunito', fontSize: '22px', fontWeight: 900, color: 'white', lineHeight: 1.2 }}>
            {announcement.title}
          </div>
        </div>

        {/* Body */}
        <div style={{ padding: '20px 22px' }}>
          {announcement.content && (
            <p style={{
              fontSize: '15px', color: 'var(--text)', lineHeight: 1.65,
              margin: '0 0 16px', whiteSpace: 'pre-wrap', fontFamily: "'Plus Jakarta Sans', sans-serif",
            }}>
              {announcement.content}
            </p>
          )}

          {announcement.subtext && (
            <p style={{
              fontSize: '13px', color: 'var(--text-dim)', lineHeight: 1.6,
              margin: '0 0 20px', whiteSpace: 'pre-wrap', borderTop: '1px solid var(--border)',
              paddingTop: '14px', fontFamily: "'Plus Jakarta Sans', sans-serif",
            }}>
              {announcement.subtext}
            </p>
          )}

          <button
            onClick={dismiss}
            style={{
              width: '100%', padding: '14px',
              background: 'linear-gradient(135deg, var(--purple), #7c3aed)',
              border: 'none', borderRadius: '16px', color: 'white',
              fontFamily: 'Nunito', fontSize: '15px', fontWeight: 800,
              cursor: 'pointer', letterSpacing: '0.3px',
            }}
          >
            Okay
          </button>
        </div>
      </div>
    </Motion>
  );
}
